module.exports = __webpack_public_path__ + "img/hr-level2addon_mining_hands_shadow.4fc4a51a.png";